var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lottieContainer",staticStyle:{"background-color":"#fff","border-radius":"8px","margin-bottom":"8px","padding-top":"8px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }